module.exports = __webpack_public_path__ + "static/media/couches-6.cfefd4e1.jpg";